import CalculateCartService from "../../../../../api/services/CalculateCartService";
import { MAPI_API_TYPE } from "@/utils";

export const getDefaultState = () => {
  return {
    promoInfo: null,
    discountedShoppingCart: null
  };
};

// initial state
export const state = getDefaultState();

// getters
const getters = {
  hasDiscount(state) {
    return !!state.promoInfo;
  },
  getPromoInfo(state) {
    return state.promoInfo;
  },
  getDiscountedCartItems(state) {
    return state.discountedShoppingCart && state.discountedShoppingCart.items;
  },
  getDiscountTaxes(state) {
    return state.discountedShoppingCart?.mapiTaxValue || 0;
  },
  getDiscountedSubTotal(state) {
    return state.promoInfo ? state.promoInfo.subtotal : null;
  },
  getCartToApplyPromo(state, getters, rootState, rootGetters) {
    const userId = rootGetters["user/getMobileUserData"]?.id || "";

    return (promoCode) => {
      return {
        cart: {
          subtotalAmount: getters.getSubTotal(),
          items: getters.getFormattedCartItems
        },
        promoCode,
        userId,
        venueId: rootGetters["venue/getActiveVenue"],
        vendorId: rootGetters["vendor/getActiveVendor"] && rootGetters["vendor/getActiveVendor"].id,
        total: getters.getFinalPrice()
      };
    };
  }
};

// actions
const actions = {
  async applyPromoCode({ dispatch, rootGetters }, promoCode) {
    const data = await dispatch("validateCart", { promoCode });
    if (rootGetters["venueSettings/APIType"] === MAPI_API_TYPE && !data.promoInfo.promoCodeApplied) {
      return Promise.reject(new Error(data.promoInfo.promoCodeMessage || "The promotional code you entered is not valid."));
    }
    return data;
  },
  async validateCart({ getters, rootGetters, dispatch }, payload) {
    const { promoCode = getters?.getPromoInfo?.promoCode || null } = payload || {};
    // cart may have been cleared when serverConfig ran
    const cartItems = rootGetters["cart/getCartItems"];
    if (!cartItems?.length) return;

    const reqBody = getters.getCartToApplyPromo(promoCode);
    return CalculateCartService.get(
      getters,
      rootGetters,
      dispatch,
      reqBody,
      rootGetters["venue/getActiveVenue"],
      rootGetters["vendor/getActiveVendor"]?.id,
      promoCode
    )
      .then((data) => {
        dispatch("setSubvendorLocationData", data);
        dispatch("applyDiscount", data);
        return Promise.resolve(data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  applyDiscount({ commit }, data) {
    const { promoInfo, cart, tax } = data;

    if (promoInfo.promoCodeApplied) {
      commit("savePromoInfo", promoInfo);
    } else {
      commit("clearPromoInfo");
    }

    commit("saveDiscountedShoppingCart", Object.assign({}, cart, { mapiTaxValue: tax }));
  },
  clearDiscount({ commit }) {
    commit("clearDiscountedShoppingCart");
    commit("clearPromoInfo");
  }
};

// mutations
const mutations = {
  savePromoInfo(state, promoInfo) {
    state.promoInfo = promoInfo;
  },
  saveDiscountedShoppingCart(state, cart) {
    state.discountedShoppingCart = cart;
  },
  clearDiscountedShoppingCart(state) {
    state.discountedShoppingCart = null;
  },
  clearPromoInfo(state) {
    state.promoInfo = null;
  },
  resetDiscountState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
